import Link from "next/link"
import { failureRecovery } from "../lib/failure-recovery.ts"
import type { RouteAction } from "../lib/route-actions.ts"
import type { FailureCause } from "../lib/user-view.ts"
import { ActionForm } from "./action-form.tsx"
import { Icon } from "./icons.tsx"

const maskedReference = (reference: string): string => `••••-${reference.slice(-4)}`

export const FailurePanel = ({ action, cause, reference }: { readonly action: RouteAction | null; readonly cause: FailureCause; readonly reference?: string | undefined }) => {
  const recovery = failureRecovery(cause)
  const commandAction = recovery.action.kind === "command" && action?.receipt.kind === "owned-resource" && action.receipt.routeId === "APP-VCH-002" ? action : null
  return (
    <output aria-live="polite" className="state-panel state-error">
      <span className="state-icon" data-state-icon="notice">
        <Icon name="notice" />
      </span>
      <h2>{recovery.heading}</h2>
      <p className="phrase-safe-block">{recovery.description}</p>
      {reference === undefined ? null : <p className="reference-copy">거래 확인 번호: {maskedReference(reference)}</p>}
      {recovery.action.kind === "link" ? (
        <div className="action-stack">
          <Link className="button primary state-action" data-state-action="link" href={recovery.action.href}>
            <Icon name="notice" />
            <span>{recovery.action.label}</span>
          </Link>
        </div>
      ) : commandAction === null ? null : (
        <ActionForm acknowledgementKind={null} action={commandAction} statusAction />
      )}
    </output>
  )
}
